import { dynamicLoader } from '~/utils';

export const CollapsiblePanel = dynamicLoader({
  name: 'CollapsiblePanel',
  importFunc: () => import('./collapsible-panel'),
});